import React, { useState, useEffect, useMemo } from "react";
import Base from "../../Config/Base";

import Pagination from "../../Config/Pagination";
import "../../../Assets/popup.css";
import "jspdf-autotable";
import "../../Config/loading.css";
import { Link, useNavigate } from "react-router-dom";
import { useLabelContext } from "../../../Context";
import { API_BASE_URL } from "../../Config/Config";
import { Footer } from "../footer/footer";

export default function Stores() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [storeData, setStoreData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [userDataSession, setUserDataSession] = useState({});
  const { setID } = useLabelContext();

  useEffect(() => {
    const userDataString =
      sessionStorage.getItem("MisUserDetails") ||
      localStorage.getItem("MisUserDetails");
    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setUserDataSession(userData);
    } else {
      console.log("User data not found in sessionStorage");
      navigate("/");
    }
  }, []);
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `${API_BASE_URL}MobileSVC/getStores?OrgId=${userDataSession.OrgId}`
        );
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        console.log(data);

        if (data.Status) {
          setStoreData(data.ResultData);
        } else {
          console.error("Fetched data is not an array:", data);
          setStoreData([]);
        }
      } catch (error) {
        console.error("Error fetching datasssss:", error);
      } finally {
        setLoading(false);
      }
    };

    if (userDataSession && userDataSession.OrgId) {
      fetchData();
    }
  }, [userDataSession.OrgId]);

  const handleReload = () => {
    window.location.reload();
  };

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  // const filteredItems = expensesData.filter(
  //   (item) =>
  //     (item.proj_name &&
  //       item.proj_name.toLowerCase().includes(searchTerm.toLowerCase())) ||
  //     (item.category_name &&
  //       item.category_name.toLowerCase().includes(searchTerm.toLowerCase())) ||
  //     (item.expense_name &&
  //       item.expense_name.toLowerCase().includes(searchTerm.toLowerCase())) ||
  //     (item.cus_name &&
  //       item.cus_name.toLowerCase().includes(searchTerm.toLowerCase()))
  // );

  const filteredItems = useMemo(() => {
    const results = storeData.filter(
      (item) =>
        item.Name && item.Name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    setCurrentPage(1);

    return results;
  }, [storeData, searchTerm]);

  // Calculate indices for slicing data
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  return (
    <Base>
      <div className="page-header">
        <div className="d-flex justify-content-between align-items-center flex-wrap">
          <div className="page-title me-3">
            <h4>Stores</h4>
            <h6>Manage your Stores</h6>
          </div>
          <div className="search-bar mb-3 ">
            <div className="input-group">
              <input
                type="text"
                name="search..........."
                placeholder="Search..."
                className="form-control"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="card-container mb-0" style={{ marginTop: "-20px" }}>
        {loading ? (
          <div className="text-center my-5">
            <div className="containers m-auto d-flex justify-content-center align-items-center">
              <div className="dot bg-primary"></div>
              <div className="dot bg-secondary"></div>
              <div className="dot bg-success"></div>
              <div className="dot bg-danger"></div>
              <div className="dot bg-warning"></div>
              <div className="dot bg-info"></div>
            </div>
            <p>Loading...</p>
          </div>
        ) : (
          currentItems &&
          currentItems.map((item, index) => (
            <div
              key={index}
              className="store-card card shadow-sm my-1"
              style={{
                border: "1px solid #ddd",
                borderRadius: "8px",
                padding: "1px",
                marginTop: "-20px",
              }}
            >
              <div className="card-body">
                <h5
                  className="card-title d-flex align-items-center mb-3"
                  style={{ color: "#007bff", fontSize: "18px" }}
                >
                  <i
                    className="fa-solid fa-shop"
                    style={{ marginRight: "10px" }}
                  ></i>
                  {item.Name}
                </h5>

                <div className="card-details">
                  <div
                    className="row"
                    style={{ color: "#6c757d", marginTop: "10px" }}
                  >
                    <div className="col-7">
                      <span>
                        <strong>
                          <i
                            className="fa-solid fa-phone"
                            style={{ color: "#007bff" }}
                          ></i>
                        </strong>
                        <a
                          href={`tel:${item.PhoneNo}`}
                          style={{
                            color: "inherit",
                            textDecoration: "none",
                          }}
                        >
                          {item.PhoneNo}
                        </a>
                      </span>
                    </div>
                    <div className="col-5">
                      <span>
                        <strong>
                          <i
                            class="fa-solid fa-qrcode"
                            style={{ color: "#007bff" }}
                          ></i>
                        </strong>{" "}
                        {item.StoreCode}
                      </span>
                    </div>
                  </div>
                  <div
                    className="row"
                    style={{ color: "#6c757d", marginTop: "10px" }}
                  >
                    <div className="col-7">
                      <span>
                        <strong>
                          <i
                            class="fa-solid fa-city"
                            style={{ color: "#007bff" }}
                          ></i>
                        </strong>{" "}
                        {item.City}
                      </span>
                    </div>
                    <div className="col-5">
                      <span>
                        <strong>
                          <i
                            class="fa-solid fa-tree-city"
                            style={{ color: "#007bff" }}
                          ></i>
                        </strong>{" "}
                        {item.State}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))
        )}
        <Pagination
          itemsPerPage={itemsPerPage}
          totalItems={storeData.length}
          paginate={paginate}
          currentPage={currentPage}
        />
      </div>

      <Footer></Footer>
    </Base>
  );
}
